import React from 'react';
import Icon from '@minecraft.icon';
import { FlexRow, BodyTextSmall, BasicContainer } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';

export const OpenCallBadge = () => {
  const { t } = useTranslation();
  return (
    <BasicContainer
      borderRadius="md"
      padding={2}
      data-testid="open-call-badge"
      className="cn_inline-block"
      bgColor="activeOpenCall"
    >
      <FlexRow gap="2" alignItems="center">
        <Icon name="open-call" themeColor="inverted" />
        <BodyTextSmall fontWeight="semibold" color="inverted">
          {t('common:label.openCall')}
        </BodyTextSmall>
      </FlexRow>
    </BasicContainer>
  );
};
